import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card,
  CardHeaderNumber,
} from './MetricsCard';
import { AppContext } from '../context/AppContext';
import { DashboardFilteresTypes } from '../util/CustomerFilterEnum';
import { getFilteredContacts } from '../util/customersUtil';
import colors from '../styles/colors';
import useMutateAnalytics from '../util/mutate.Analytics';
import analyticsKeys from "../util/UsageStatLinks";


export default function CouponsExpired({ metrics, timeRange }) {
  const { setApp } = useContext(AppContext);

  const isClickable = metrics?.couponsExpiredWithoutRedemption > 0;

  const onClickHandler = () => getFilteredContacts(setApp, history, {
    type: DashboardFilteresTypes.DiscountsExpiredWithoutRedemption,
    ...timeRange,
  });

	const mutateAnalytics = useMutateAnalytics()

  const history = useHistory();

  return (
    <Card title="Discounts Expired Without Redemption">
      <CardHeaderNumber
        color={isClickable ? colors.seaGreen : colors.grey2}
        onClick={isClickable ? () => {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_DISCOUNT_EXPIRED_WITHOUT_REDEMPTION,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler();
        } : null}
      >
        {metrics?.couponsExpiredWithoutRedemption.toString()}
      </CardHeaderNumber>
    </Card>
  );
}
